import React, { useId } from 'react';
import { cn } from '@/lib/utils';

// Input variants
export const inputVariants = {
  base: 'flex h-10 w-full rounded-md border border-border bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
} as const;

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, helperText, id, name, ...props }, ref) => {
    // Use provided id, name-based id, or generate a stable id
    const generatedId = useId();
    const inputId = id || (name ? `input-${name}` : generatedId);

    return (
      <div className="space-y-1">
        {label && (
          <label htmlFor={inputId} className="text-foreground block text-sm font-medium">
            {label}
          </label>
        )}
        <input
          id={inputId}
          name={name}
          className={cn(inputVariants.base, error && 'border-red-500', className)}
          ref={ref}
          {...props}
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
        {helperText && !error && <p className="text-muted text-sm">{helperText}</p>}
      </div>
    );
  },
);
Input.displayName = 'Input';
